import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Box, Typography } from '@material-ui/core';
import { Room } from '@material-ui/icons';
import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';
import StatusChip from 'modules/views/shared/StatusChip';
import { ResourceModel, SearchModel } from 'modules/models';
import { getDrawerButton } from 'utils';
import { getDrawerButton as getClientDrawerButton, getClientLabel } from 'utils/clientUtils';
import { avatarGlobalStyles } from 'assets/styles';
import { useStyles as statusChipStyles } from 'modules/views/shared/StatusChip/styles';
import { useStyles } from '../styles';
import { CompanyLabel, CompanyType } from 'modules/models/client';

const ResultWithAddress = ({
  onClick,
  item,
  setClientForBranches,
}: {
  onClick: () => void;
  item: SearchModel.IResponse;
  setClientForBranches?: (item: any) => void;
}) => {
  const classes = useStyles({});
  const avatarGlobalClasses = avatarGlobalStyles();
  const statusChipClasses = statusChipStyles();
  const { buttonText, linkTo } = useMemo(
    () =>
      item.entityType === SearchModel.SearchType.Project
        ? getDrawerButton(item.status, item.id, ResourceModel.Type.PROJECT)
        : getClientDrawerButton(item.status, item.id),
    [item]
  );
  const statusLabel = ResourceModel.statusMap[item.status];
  const statusClass = useMemo(() => statusChipClasses[statusLabel?.replace(/ /g, '').toLowerCase()], [statusChipClasses, statusLabel]);
  const address = useMemo(
    () =>
      item?.address
        ? [item.entityType === SearchModel.SearchType.Project ? item.address.line1 : null, item.address.city, item.address.stateName]
            .filter(_item => !!_item)
            .join(', ')
        : null,
    [item]
  );

  return (
    <Link
      className={classes.searchResult}
      onClick={linkTo ? onClick : undefined}
      title={buttonText + ' (' + item.name + ')'}
      to={linkTo}
      component={!linkTo ? Box : undefined}
    >
      <Avatar className={`${avatarGlobalClasses.avatarWrapper} ${avatarGlobalClasses.avatarBig}`}>
        <Room />
      </Avatar>
      <Box className={classes.searchResultName}>
        <Typography style={{ maxWidth: '100%', overflow: 'visible', display: 'flex' }}>
          <span
            style={{
              float: 'left',
              display: 'inline-block',
              // maxWidth: 'calc(100% - 51px)',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {item.name}
          </span>
          {item.entityType === SearchModel.SearchType.Company && (
            <span
              style={{
                float: 'left',
                display: 'inline-block',
              }}
            >
              {(item.companyLabel === CompanyLabel.HO ||
                item.companyLabel === CompanyLabel.B ||
                item.companyLabel === CompanyLabel.SB ||
                item.companyLabel === CompanyLabel.JV) && (
                <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>{getClientLabel(item.companyLabel, false)}</span>
              )}
              {(item.companyType === CompanyType.HeadOffice || item.companyType === CompanyType.Branch) && (
                <ArrowDropDownRoundedIcon
                  id={'co-' + item.id}
                  fontSize="medium"
                  style={{ marginTop: '-5px', verticalAlign: 'top' }}
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    setClientForBranches(item);
                  }}
                />
              )}
            </span>
          )}
        </Typography>
        {!!address && <Typography>{address}</Typography>}
      </Box>
      {statusLabel && <StatusChip label={statusLabel} styleClasses={statusClass} />}
    </Link>
  );
};

export default ResultWithAddress;
